module.exports = __webpack_public_path__ + "25232ad59bd5df7d977e57f027f783e1.svg";